import { constantToSelect } from './constantToSelect';
import { dataToSelect } from './dataToSelect';

const currentYear = new Date().getFullYear();
const appName = 'The Stock Vault';
const author = 'Sensi Labs';

export { constantToSelect, dataToSelect, author, appName, currentYear };
